export function formatAppVersion(appVersion: string, gitSha = ''): string {
  const versionLabel = appVersion === 'main' && gitSha
    ? `${appVersion}+${gitSha.slice(0, 7)}`
    : appVersion;

  return /^\d/.test(versionLabel) ? `v${versionLabel}` : versionLabel;
}
